import { baseUrl, solomonBaseUrl, request, apiHubBaseUrl } from '@/libs/api-request'
import { HTTP_STATUS } from '@/libs/constants'
import axios from 'axios'

const authFailedStatus = [ HTTP_STATUS.unauthrized ]

export function createAIReportData (params, force = true) {
  const url = baseUrl() + `/ai/journeymap/create_report`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function createAIReportPrefix (params, force = true) {
  const url = baseUrl() + `/ai/journeymap/create_report_prefix`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getAIReportData (aiReportId, force = true) {
  const url = baseUrl() + `/ai/journeymap/report/${aiReportId}`

  const config = {
    method: 'get',
    url
  }

  return request(config, force)
}

export function getMineListData (params, force = true) {
  const url = baseUrl() + `/ai/journeymap/mine_list`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function createMineData (params, force = true) {
  const url = baseUrl() + `/ai/journeymap/create_report_mine`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getAIReportDashBoard (params, force = true) {
  const url = baseUrl() + `/ai/journeymap/aireport_dashboard`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getAIReportPlan (aiReportId, force = true) {
  const url = baseUrl() + `/ai/journeymap/plan_list`

  const config = {
    method: 'get',
    url
  }

  return request(config, force)
}

export function getAiCategoryList (force = true) {
  const url = baseUrl() + `/ai/journeymap/get_ai_category_list`

  const config = {
    method: 'post',
    url
  }

  return request(config, force)
}

export function getAiCategoryCount (force = true) {
  const url = baseUrl() + `/ai/journeymap/get_ai_category_count`

  const config = {
    method: 'post',
    url
  }

  return request(config, force)
}

export function getRankBenchmark (params, force = true) {
  const url = baseUrl() + `/ai/journeymap/get_ranking_benchmark`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getTrendBenchmark (params, force = true) {
  const url = baseUrl() + `/ai/journeymap/get_trend_benchmark`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getMineCount (params, force = true) {
  const url = baseUrl() + `/ai/journeymap/mine_count`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function checkReportDuplicate (params, force = true) {
  const url = baseUrl() + `/ai/journeymap/report_check`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function createReportMashup (params, force = true) {
  const url = baseUrl() + `/ai/journeymap/create_report_mashup`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getSegmentMeta (params, force = true) {
  const url = baseUrl() + `/ai/journeymap/get_segment_meta`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getSegmentOptions (params, force = true) {
  const url = baseUrl() + `/ai/journeymap/get_segment_options`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getRemainReportCredit (force = true) {
  const url = baseUrl() + `/ai/journeymap/get_remain_credit`

  const config = {
    method: 'get',
    url
  }

  return request(config, force)
}

export function getReportCreditHistory (force = true) {
  const url = baseUrl() + `/ai/journeymap/get_report_credit_history`

  const config = {
    method: 'get',
    url
  }

  return request(config, force)
}

export function retryReport (params, force = true) {
  const url = baseUrl() + `/ai/journeymap/retry_report`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

// chatbot

export function docentCheck (force = true) {
  const url = baseUrl() + `/ai/journeymap/docent_check`

  const config = {
    method: 'get',
    url
  }

  return request(config, force)
}

export function heatmapDocentCheck (params, force = true) {
  const url = apiHubBaseUrl() + `/v1/heatmap/ai/docent_check`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function docentStop (force = true) {
  const url = baseUrl() + `/ai/journeymap/docent_stop`

  const config = {
    method: 'post',
    url,
    data: {
      sessionKey: sessionStorage.getItem('reportchat_sessionKey')
    }
  }

  return request(config, force)
}

let aborter = new AbortController()

export async function connect (category, onConnect = false) {
  const token = sessionStorage.getItem(`${category}_accessToken`)
  const headers = {
    headers: token && {
      Authorization: `Bearer ${token}`
    },
    withCredentials: true
  }

  return new Promise((resolve, reject) => {
    axios
      .get(`${solomonBaseUrl()}/hello`, headers)
      .then((res) => {
        if (onConnect) onConnect()
        const accessToken = res.data.access_token
        const refreshToken = res.data.refresh_token
        const sessionKey = res.data.res.data
        if (accessToken) sessionStorage.setItem(`${category}_accessToken`, accessToken)
        if (refreshToken) sessionStorage.setItem(`${category}_refreshToken`, refreshToken)
        if (sessionKey) sessionStorage.setItem(`${category}_sessionKey`, sessionKey)
        resolve()
      })
      .catch((e) => {
        if (authFailedStatus.includes(e.response.status)) {
          refresh(category, onConnect)
        }
        reject(new Error(e))
      })
  })
}

export function refresh (category, onConnect = false) {
  const config = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem(
        `${category}_refreshToken`
      )}`
    },
    withCredentials: true
  }

  axios
    .get(`${solomonBaseUrl()}/refresh`, config)
    .then((res) => {
      if (onConnect) onConnect()
      const accessToken = res.data.access_token
      sessionStorage.setItem(`${category}_accessToken`, accessToken)
    })
    .catch((e) => {
      console.log(e)
      if (authFailedStatus.includes(e.response.status)) {
        sessionStorage.removeItem(`${category}_accessToken`)
        sessionStorage.removeItem(`${category}_refreshToken`)
        sessionStorage.removeItem(`${category}_sessionKey`)
        connect(category, onConnect)
      }
    })
}

export const setReportForChat = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem('reportchat_accessToken')}`
    }
  }
  return axios.post(`${solomonBaseUrl()}/question/set_report`, data, config)
}

export async function askQuestion (category, data, onStart, onDataCallback, onEnd) {
  aborter.abort()
  aborter = new AbortController()

  let headers = {
    Authorization: `Bearer ${sessionStorage.getItem(`${category}_accessToken`)}`,
    'Content-Type': 'application/json'
  }

  fetch(`${solomonBaseUrl()}/question/ask`, {
    credentials: 'include',
    signal: aborter.signal,
    method: 'POST',
    headers,
    body: JSON.stringify(data)
  })
    .then((response) => {
      if (!response.ok) {
        if (authFailedStatus.includes(response.status)) {
          onEnd(null, 'error')
          refresh(category)
        }
        throw response
      }

      return response
    })
    .then(async (response) => {
      console.log(response, 'Start generation')
      onStart(response)

      const loopRunner = true
      const reader = response.body.getReader()
      const decoder = new TextDecoder()

      while (loopRunner) {
        const { done, value } = await reader.read()

        if (done) {
          onEnd(response)
          break
        }

        const decoded = decoder.decode(value, { stream: true })
        onDataCallback(decoded)
      }
    })
    .catch((e) => {
      if (aborter.signal.aborted) {
        console.log('Abort generation')
      }

      onEnd(null, e)
      console.log(e)
    })
}

export function abortRendering () {
  try {
    aborter.abort()
  } catch (e) {
    console.log(e)
  }
}

export const setSummary = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem('reportchat_accessToken')}`
    }
  }
  return axios.post(`${solomonBaseUrl()}/question/insert_init_reportchat_row`, data, config)
}

export const rateAnswer = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem('reportchat_accessToken')}`
    }
  }
  return axios.post(`${solomonBaseUrl()}/question/update_rating`, data, config)
}

export const getTokenStatus = (id, category) => {
  const config = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem(`${category}_accessToken`)}`
    }
  }
  return axios.get(`${solomonBaseUrl()}/question/get_token_for_reportchat?Id=${id}`, config)
}

export const resetReportChat = (category) => {
  const config = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem(`${category}_accessToken`)}`
    }
  }
  return axios.get(`${solomonBaseUrl()}/question/reset_report`, config)
    .then((res) => {
      const accessToken = res.data.access_token
      const refreshToken = res.data.refresh_token
      const sessionKey = res.data.res.data
      if (accessToken) sessionStorage.setItem(`${category}_accessToken`, accessToken)
      if (refreshToken) sessionStorage.setItem(`${category}_refreshToken`, refreshToken)
      if (sessionKey) sessionStorage.setItem(`${category}_sessionKey`, sessionKey)
    })
    .catch((e) => {
      console.log(e)
    })
}

export const getHistory = (category) => {
  const config = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem(`${category}_accessToken`)}`
    }
  }
  return axios.get(`${solomonBaseUrl()}/question/get?category=${category}`, config)
}

export const createDashboard = (params, force = true) => {
  const url = baseUrl() + `/ai/journeymap/ask_dashboard`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export const editReportTitle = (params, force = true) => {
  const url = baseUrl() + `/ai/journeymap/update_title`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export const cancelDashboardReport = (params, force = true) => {
  const url = baseUrl() + `/ai/journeymap/cancel_dashboard`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}
